import React from "react";
import {ViewVariation} from './ViewVariation';
import type {ViewVariationProps} from './ViewVariation'

import { ErrorBoundary } from "react-error-boundary";


export const SharedDynamicViewVariation = (props: ViewVariationProps) => {
    return (
        <ErrorBoundary fallback={<ViewVariation {...props} />}>
            <ViewVariation {...props} />
        </ErrorBoundary>
    )
}
